import { Routes } from '@angular/router';
import { DetailService } from '@app/admin/disapproval-reasons/detail/services/detail.service';

export const disapprovalReasonsRoutes: Routes = [
  {
    path: '',
    loadComponent: () => import('@app/admin/disapproval-reasons/overview/overview.component').then(component => component.OverviewComponent),
  },
  {
    path: ':id',
    loadComponent: () => import('@app/admin/disapproval-reasons/detail/detail.component').then(component => component.DetailComponent),
    providers: [DetailService],
  },
  {
    path: '**',
    redirectTo: '',
  },
];
